import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-service-register";

// Xuất Excel Báo cáo dịch vụ
export const exportExcelPatientRegisterServiceReport = (searchObject) => {
  return axios({
    method: "post",
    url: API_PATH + "/export-excel-psr-report",
    data: searchObject,
    responseType: "blob",
  });
};

// Báo cáo dịch vụ
export const pagingPatientServiceRegisterReport = (obj) =>
  axios.post(API_PATH + "/paging-psr-report", obj);

export const changePaSvRes = (obj) =>
  axios.post(API_PATH + "/change-pa-sv-res", obj);

//
export const getListPrintRequest = (searchObject) =>
  axios.post(API_PATH + "/get-list-print-request", searchObject);

export const getServiceRequestByDay = (searchObject) =>
  axios.post(API_PATH + "/get-list-sv-request-day", searchObject);

export const removeSvItem = (id) =>
  axios.delete(API_PATH + "/remove-sv-item/" + id);

export const getListHospitalBedSVRequest = (obj) =>
  axios.post(API_PATH + "/get-list-hospital-bed-service-request", obj);

export const saveHospitalBedSVRequest = (obj) =>
  axios.post(API_PATH + "/save-hospital-bed-service-request", obj);

export const getHospitalBedSVRequestById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const updateSvItemToOrder = (obj) =>
  axios.post(API_PATH + "/update-sv-item-to-order", obj);

export const getListSvItem = (obj) =>
  axios.post(API_PATH + "/get-list-sv-item", obj);

export const updateSampleCodeForItem = (obj) =>
  axios.post(API_PATH + "/update-sample-code-of-sv-item", obj);

export const returnResultForListItem = (obj) =>
  axios.post(API_PATH + "/return-result-for-list-item", obj);

export const returnResultForItem = (obj) =>
  axios.post(API_PATH + "/return-result-for-item", obj);

export const cancelReturnResultForListItem = (obj) =>
  axios.post(API_PATH + "/cancel-return-result-for-list-item", obj);

export const cancelReturnResultForItem = (obj) =>
  axios.post(API_PATH + "/cancel-return-result-for-item", obj);

export const cancelSampledForListItem = (obj) =>
  axios.post(API_PATH + "/cancel-sampled-for-list-item", obj);

export const cancelReportForListItem = (obj) =>
  axios.post(API_PATH + "/cancel-report-for-list-item", obj);

export const getInitMedicalSupplyListItem = (obj) =>
  axios.post(API_PATH + "/get-init-medical-supply-by-list-item", obj);

export const updateHandleSampleCode = (obj) =>
  axios.post(API_PATH + "/update-handle-sample-code", obj);

export const getListServiceDesignation = (searchObject) =>
  axios.post(API_PATH + "/get-list-service-designation", searchObject);
export const returnResultCampaign = (searchObject) =>
  axios.post(API_PATH + "/return-result-by-campaign-id", searchObject);

export const checkDuplicateSampleCodeService = (searchObject) =>
  axios.post(API_PATH + "/check-duplicate-handle-sample-code", searchObject);

// API LA
export const saveServiceItem = (obj) =>
  axios.post(API_PATH + "/save-or-update", obj);

export const pagingServiceItem = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

export const searchPatientServiceRegisterReport = (obj) =>
  axios.post(API_PATH + "/search-patient-service-register-report", obj);

export const voidSvitemAndOrther = (id) =>
  axios.delete(API_PATH + "/remove/" + id);

export const pagingUncompletedRegisterService = (obj) =>
  axios.post(API_PATH + "/get-pa-service-register-uncompleted", obj);

export const getDefaultServicesByAppointmentCheckInDate = (obj) =>
  axios.post(
    API_PATH + "/get-default-services-by-appointment-check-in-date",
    obj
  );

export const allocateRoomsForUncompletedServices = (obj) =>
  axios.post(API_PATH + "/allocate-rooms-for-uncompleted-services", obj);

export const getLatestVisitBeforeAllocateRoom = (obj) =>
  axios.post(API_PATH + "/latest-visit-before-allocate-room", obj);

export const getLatestVisitBeforeAllocateRoomByDepartment = (obj) =>
  axios.post(API_PATH + "/latest-visit-by-patient-and-department", obj);

export const pagingServiceRequestItemByPatientServiceRegisterInfo = (obj) =>
  axios.post(API_PATH + "/paging-sri-by-service-register-info", obj);

export const getListPaServiceRes = (searchObject) =>
  axios.post(API_PATH + "/get-list-pa-service-res", searchObject);

export const voidedServiceRequestItemFromPatientServiceRegister = (id) =>
  axios.delete(API_PATH + "/delete-sri-from-patient-service-register/" + id);

export const saveListPaServiceRes = (obj) =>
  axios.post(API_PATH + "/save-list-pa-service-res", obj);

export const initChangePaSvRes = (patientSvResId) =>
  axios.get(API_PATH + `/init-change-pa-sv-res/${patientSvResId}`);

export const updateTotalTreatmentTimesOfService = (totaltreat, pasId) =>
  axios.get(
    API_PATH + `/update-total-treatment-times-of-service/${totaltreat}/${pasId}`
  );

export const assignWarrantyService = (obj) =>
  axios.post(API_PATH + "/assign-warranty-service", obj);

export const updateMainServiceRegister = (obj) =>
  axios.post(API_PATH + "/update-main-service-register", obj);
